import React from "react";
import { AdminGuard } from "../../guards/RolesGuard";
import Navigation from "./Navigation";
import { NavLink } from "react-router-dom";

const Sidebar = () => {

    const isAdmin = AdminGuard()

    return (
        <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0 ">
            <div className="flex flex-col flex-grow pt-5 !bg-[#00330F] overflow-y-auto">
                <div className="mb-5">
                    <NavLink className="m-auto md:w-56" to="/">
                        {/* Logo here */}
                        <img className="max-h-8 w-auto" src="/assets/auth/navigation-logo.svg" alt="logo" />

                    </NavLink>
                </div>
                <div className="mt-8 flex-1 flex flex-col">
                    <nav className="flex-1 px-4 pb-4">
                        <Navigation />
                    </nav>
                </div>
            </div>
        </div>
    )
}

export default Sidebar;